import React from "react";
import { CircularProgress } from "@mui/material";
import s from "./styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";
import logo from "../../media/img/logo.png";

interface LoadingScreenProps {
  message?: string;
  showLogo?: boolean;
  showSpinner?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message,
  showLogo = true,
  showSpinner = true,
}) => {
  return (
    <div className={s.container}>
      <div className={s.content}>
        {showLogo && (
          <img src={logo} alt="ViewSpark Logo" className={s.logo} />
        )}
        {showSpinner && (
          <div className={s.spinnerWrapper}>
            <CircularProgress
              size={40}
              thickness={4}
              className={s.spinner}
            />
          </div>
        )}
        {message && <p className={s.message}>{message}</p>}
      </div>
    </div>
  );
};

export default withStyles(s)(LoadingScreen);
